import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material'

/** Indicador do dashboard: rótulo, valor e ícone colorido. */
const StatCard = ({ label, value, icon: Icon, color = '#1976d2', hint, loading = false }) => (
  <Card variant="outlined" sx={{ height: '100%' }}>
    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {Icon && (
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: `${color}1A`,
            color,
            flexShrink: 0,
          }}
        >
          <Icon />
        </Box>
      )}
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" color="text.secondary" noWrap>
          {label}
        </Typography>
        {loading ? (
          <Skeleton variant="text" width={80} height={36} />
        ) : (
          <Typography variant="h5" fontWeight={600}>
            {value}
          </Typography>
        )}
        {hint && (
          <Typography variant="caption" color="text.secondary">
            {hint}
          </Typography>
        )}
      </Box>
    </CardContent>
  </Card>
)

export default StatCard
